<template>
    <div class="mh-100 h-100">
        <div v-if="currentJob.state === 'processing'" class="h-100 mh-100">
            <div class="gallery-16 overflow-hidden">
                <div class="gallery-row d-flex justify-content-center loading">
                    <div v-for="idx in 4" :key="idx" class="image align-items-end">
                        <img :src="loadingImage" />
                    </div>
                </div>
                <div class="gallery-row d-flex justify-content-center loading">
                    <div v-for="idx in 4" :key="idx" class="image align-items-center">
                        <img :src="loadingImage" />
                    </div>
                </div>
                <div class="gallery-row d-flex justify-content-center loading">
                    <div v-for="idx in 4" :key="idx" class="image align-items-center">
                        <img :src="loadingImage" />
                    </div>
                </div>
                <div class="gallery-row d-flex justify-content-center loading">
                    <div v-for="idx in 4" :key="idx" class="image align-items-start">
                        <img :src="loadingImage" />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="currentJob.state === 'completed'" class="h-100 mh-100">
            <div class="gallery-16 overflow-hidden">
                <div class="gallery-row d-flex justify-content-center">
                    <div class="image align-items-end">
                        <router-link
                            v-slot="{ href, route, navigate, isActive, isExactActive }"
                            :to="{
                                name: 'SelectedImageCanvas',
                                params: { uuid: id, selected_image: 0 },
                            }"
                        >
                            <img :src="currentJob.base64_output_images[0]" @click="navigate" class="result-img" />
                        </router-link>
                    </div>
                    <div class="image align-items-end">
                        <router-link
                            v-slot="{ href, route, navigate, isActive, isExactActive }"
                            :to="{
                                name: 'SelectedImageCanvas',
                                params: { uuid: id, selected_image: 1 },
                            }"
                        >
                            <img :src="currentJob.base64_output_images[1]" @click="navigate" class="result-img" />
                        </router-link>
                    </div>
                    <div class="image align-items-end">
                        <router-link
                            v-slot="{ href, route, navigate, isActive, isExactActive }"
                            :to="{
                                name: 'SelectedImageCanvas',
                                params: { uuid: id, selected_image: 2 },
                            }"
                        >
                            <img :src="currentJob.base64_output_images[2]" @click="navigate" class="result-img" />
                        </router-link>
                    </div>
                    <div class="image align-items-end">
                        <router-link
                            v-slot="{ href, route, navigate, isActive, isExactActive }"
                            :to="{
                                name: 'SelectedImageCanvas',
                                params: { uuid: id, selected_image: 3 },
                            }"
                        >
                            <img :src="currentJob.base64_output_images[3]" @click="navigate" class="result-img" />
                        </router-link>
                    </div>
                </div>
                <div class="gallery-row d-flex justify-content-center">
                    <div class="image align-items-center">
                        <router-link
                            v-slot="{ href, route, navigate, isActive, isExactActive }"
                            :to="{
                                name: 'SelectedImageCanvas',
                                params: { uuid: id, selected_image: 4 },
                            }"
                        >
                            <img :src="currentJob.base64_output_images[4]" @click="navigate" class="result-img" />
                        </router-link>
                    </div>
                    <div class="image align-items-center">
                        <router-link
                            v-slot="{ href, route, navigate, isActive, isExactActive }"
                            :to="{
                                name: 'SelectedImageCanvas',
                                params: { uuid: id, selected_image: 5 },
                            }"
                        >
                            <img :src="currentJob.base64_output_images[5]" @click="navigate" class="result-img" />
                        </router-link>
                    </div>
                    <div class="image align-items-center">
                        <router-link
                            v-slot="{ href, route, navigate, isActive, isExactActive }"
                            :to="{
                                name: 'SelectedImageCanvas',
                                params: { uuid: id, selected_image: 6 },
                            }"
                        >
                            <img :src="currentJob.base64_output_images[6]" @click="navigate" class="result-img" />
                        </router-link>
                    </div>
                    <div class="image align-items-center">
                        <router-link
                            v-slot="{ href, route, navigate, isActive, isExactActive }"
                            :to="{
                                name: 'SelectedImageCanvas',
                                params: { uuid: id, selected_image: 7 },
                            }"
                        >
                            <img :src="currentJob.base64_output_images[7]" @click="navigate" class="result-img" />
                        </router-link>
                    </div>
                </div>
                <div class="gallery-row d-flex justify-content-center">
                    <div class="image align-items-center">
                        <router-link
                            v-slot="{ href, route, navigate, isActive, isExactActive }"
                            :to="{
                                name: 'SelectedImageCanvas',
                                params: { uuid: id, selected_image: 8 },
                            }"
                        >
                            <img :src="currentJob.base64_output_images[8]" @click="navigate" class="result-img" />
                        </router-link>
                    </div>
                    <div class="image align-items-center">
                        <router-link
                            v-slot="{ href, route, navigate, isActive, isExactActive }"
                            :to="{
                                name: 'SelectedImageCanvas',
                                params: { uuid: id, selected_image: 9 },
                            }"
                        >
                            <img :src="currentJob.base64_output_images[9]" @click="navigate" class="result-img" />
                        </router-link>
                    </div>
                    <div class="image align-items-center">
                        <router-link
                            v-slot="{ href, route, navigate, isActive, isExactActive }"
                            :to="{
                                name: 'SelectedImageCanvas',
                                params: { uuid: id, selected_image: 10 },
                            }"
                        >
                            <img :src="currentJob.base64_output_images[10]" @click="navigate" class="result-img" />
                        </router-link>
                    </div>
                    <div class="image align-items-center">
                        <router-link
                            v-slot="{ href, route, navigate, isActive, isExactActive }"
                            :to="{
                                name: 'SelectedImageCanvas',
                                params: { uuid: id, selected_image: 11 },
                            }"
                        >
                            <img :src="currentJob.base64_output_images[11]" @click="navigate" class="result-img" />
                        </router-link>
                    </div>
                </div>
                <div class="gallery-row d-flex justify-content-center">
                    <div class="image align-items-start">
                        <router-link
                            v-slot="{ href, route, navigate, isActive, isExactActive }"
                            :to="{
                                name: 'SelectedImageCanvas',
                                params: { uuid: id, selected_image: 12 },
                            }"
                        >
                            <img :src="currentJob.base64_output_images[12]" @click="navigate" class="result-img" />
                        </router-link>
                    </div>
                    <div class="image align-items-start">
                        <router-link
                            v-slot="{ href, route, navigate, isActive, isExactActive }"
                            :to="{
                                name: 'SelectedImageCanvas',
                                params: { uuid: id, selected_image: 13 },
                            }"
                        >
                            <img :src="currentJob.base64_output_images[13]" @click="navigate" class="result-img" />
                        </router-link>
                    </div>
                    <div class="image align-items-start">
                        <router-link
                            v-slot="{ href, route, navigate, isActive, isExactActive }"
                            :to="{
                                name: 'SelectedImageCanvas',
                                params: { uuid: id, selected_image: 14 },
                            }"
                        >
                            <img :src="currentJob.base64_output_images[14]" @click="navigate" class="result-img" />
                        </router-link>
                    </div>
                    <div class="image align-items-start">
                        <router-link
                            v-slot="{ href, route, navigate, isActive, isExactActive }"
                            :to="{
                                name: 'SelectedImageCanvas',
                                params: { uuid: id, selected_image: 15 },
                            }"
                        >
                            <img :src="currentJob.base64_output_images[15]" @click="navigate" class="result-img" />
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import store from './../../../mixins/store.mixin';
import currentJob from './../../../mixins/current_job.mixin';
import AspectRatioManager from '../../../manager/AspectRatioManager';

export default {
    name: 'SixteenImagesView',
    props: {},
    components: {},
    mixins: [store, currentJob],
    data() {
        return {};
    },
    mounted: function () {},
    created: function () {},
    methods: {},
    computed: {
        loadingImage() {
            return AspectRatioManager.getBySize(this.currentJob.settings.conversion.options.aspect_ratio).loading;
        },
    },
};
</script>
<style lang="scss">
.gallery-16 {
    height: 100%;
    gap: 10px;
    display: flex;
    flex-direction: column;
    padding: 10px;

    .gallery-row {
        height: calc(26% - 20px);
        gap: 10px;
        flex: 1;
    }

    .image {
        display: flex;
        gap: 10px;
        height: 100%;
        width: max-content;

        img {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
            object-fit: contain;
        }
    }
}
</style>
